export default function getDeletedReactionCount(
  content: string | null | undefined,
  reactionCount: { [key: string]: number }[] | null | undefined,
) {
  if (!content) {
    return reactionCount || [];
  }

  const reactionCounts = [...(reactionCount || [])];
  const index = reactionCounts.findIndex((item) =>
    Object.hasOwn(item, content),
  );

  if (index === -1) {
    return reactionCounts;
  }

  const entry = reactionCounts[index];
  const currentCount = Number(entry[content] || 0);

  if (currentCount <= 1) {
    return reactionCounts.filter((_, itemIndex) => itemIndex !== index);
  }

  return reactionCounts.map((item, itemIndex) => {
    if (itemIndex !== index) {
      return item;
    }

    return {
      ...item,
      [content]: currentCount - 1,
    };
  });
}
